import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Injector,
  Input,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTooltip } from '@angular/material/tooltip';
import { DirectiveSuperclass } from '@sama/ng-core';
import { map } from 'rxjs/operators';
import { WorkspaceLoadingService } from '../../../shared/misc-services/workspace-loading.service';
import { TaskWorkspaceStore } from '../../h3ml/state/task-workspace-store';
import { SubmitTaskDialogComponent } from '../submit-task-dialog/submit-task-dialog.component';
import { TimerService } from '../timer-badge/timer.service';
import { SubmitTaskButtonService } from './submit-task-button.service';

@Component({
  selector: 'h3-submit-task-button',
  templateUrl: './submit-task-button.component.html',
  styleUrls: ['./submit-task-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  hostDirectives: [MatTooltip],
  standalone: false,
})
export class SubmitTaskButtonComponent extends DirectiveSuperclass {
  @Input() withConfirmation = false;

  private readonly submitTaskButtonService = inject(SubmitTaskButtonService);
  private readonly store = inject(TaskWorkspaceStore);
  private readonly matTooltip = inject(MatTooltip);
  private readonly matDialog = inject(MatDialog);
  private readonly injector = inject(Injector);
  private readonly timerService = inject(TimerService);
  private readonly workspaceLoadingService = inject(WorkspaceLoadingService);

  unsubmittableReason$ =
    this.submitTaskButtonService.buildUnsubmittableReason$();
  isProductionWorkspace = this.store.state().workspace === 'production';

  submitDisabled$ = this.unsubmittableReason$.pipe(map(Boolean));

  constructor() {
    super();
    this.subscribeTo(this.unsubmittableReason$, (unsubmittableReason) => {
      this.matTooltip.message = unsubmittableReason;
    });
  }

  async submitOrConfirm() {
    this.timerService.pause(performance.now());
    if (this.withConfirmation) {
      this.workspaceLoadingService.withOverlay$.next(false);
      const dialogRef = this.matDialog.open(SubmitTaskDialogComponent, {
        width: '527px',
        height: '336px',
        injector: this.injector,
        backdropClass: 'dialog-backdrop',
      });
      this.subscribeTo(dialogRef.afterClosed(), () => {
        this.timerService.resume();
        this.workspaceLoadingService.withOverlay$.next(true);
      });
      this.workspaceLoadingService.onReset(() => dialogRef.close());
    } else {
      await this.submitTaskButtonService.submit();
      this.timerService.resume();
    }
  }
}
